module.exports = "/_next/static/images/SyncData@2x-ea54a44598b86b44dca0e31600a5c3b6.png";